import AnchorLink from 'react-anchor-link-smooth-scroll'
import Img from 'gatsby-image'
import React from 'react'

class LeadComponentServices extends React.Component {
  render() {
    const { language, leadText, subText } = this.props
    let sketchHeader = 'Planung'
    let sketchDetails = 'Ob MVP oder Enterprise-Applikation. Wir unterstützen Sie aktiv bei der Planung. Inklusive Wireframing und Prototyping.'
    let designHeader = 'Design'
    let designDetails = 'Beim Design stellen wir sicher, dass Ihre Software nicht nur gut aussieht, sondern auch benutzerfreundlich ist.'
    let codeHeader = 'Entwicklung'
    let codeDetails = 'Bei der Programmierung setzen wir auf Meteor.js (Node.js, Blaze, React), womit wir Ihre Vision effizient umsetzen.'
    let testHeader = 'Testing'
    let testDetails = 'Code-Qualität ist uns sehr wichtig. Durch Test-Driven-Development stellen wir sicher, dass Ihre Applikation auch bei neuen Features fehlerfrei bleibt.'
    let deployHeader = 'Deployment'
    let deployDetails = 'Wir bringen Ihre Software ins Netz und sorgen dafür, dass sie skalierbar ist. Auf Wunsch inklusive Continuous Delivery.'
    let analHeader = 'Analytics'
    let analDetails = 'Wir machen den Erfolg messbar und implementieren Growth-Marketing Metriken. Damit Sie Ihre Ressourcen weise einsetzen und den Überblick behalten.'
    if (language==='en') {
      sketchHeader = 'Wireframing'
      sketchDetails = 'MVP or Enterprise. We support your planning-process. Including wireframing und prototyping.'
      designHeader = 'Design'
      designDetails = 'We make sure that your software looks good and is user-friendly.'
      codeHeader = 'Development'
      codeDetails = 'We are specialized on Meteor.js, which allows us to quickly implement your vision.'
      testHeader = 'Testing'
      testDetails = 'We use Test-Driven-Development to ensure the code-quality of your app.'
      deployHeader = 'Deployment'
      deployDetails = 'We can deploy your software and make sure that it is scalable. Including Continuous Delivery.'
      analHeader = 'Analytics'
      analDetails = `Let's measure your success and implement growth-hacking metrics, so you know what features are really used and how your software is percieved.`
    }
    return (
      <div id="fh5co-our-services">
        <div className="container">
          <div className="row">
            <div className="box">
              <div className="icon colored-1"><span><i className="fas fa-pencil-alt"></i></span></div>
              <h3>{sketchHeader}</h3>
              <p>{sketchDetails}</p>
            </div>
            <div className="box">
              <div className="icon colored-2"><span><i className="fas fa-images"></i></span></div>
              <h3>{designHeader}</h3>
              <p>{designDetails}</p>
            </div>
            <div className="box">
              <div className="icon colored-3"><span><i className="fas fa-code"></i></span></div>
              <h3>{codeHeader}</h3>
              <p>{codeDetails}</p>
            </div>
              <div className="box">
                <div className="icon colored-4"><span><i className="fas fa-fire"></i></span></div>
                <h3>{testHeader}</h3>
                <p>{testDetails}</p>
              </div>
              <div className="box">
                <div className="icon colored-5"><span><i className="fas fa-cloud-upload-alt"></i></span></div>
                <h3>{deployHeader}</h3>
                <p>{deployDetails}</p>
              </div>
              <div className="box">
                <div className="icon colored-6"><span><i className="fas fa-chart-line"></i></span></div>
                <h3>{analHeader}</h3>
                <p>{analDetails}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Img sizes={this.props.imageStore.toolsImage.sizes} alt="Meteor.js" title="Meteor.js" className="toolkit-image"/>
              </div>
            </div>
        </div>
      </div>
    )
  }
}

export default LeadComponentServices



// WEBPACK FOOTER //
// ./src/components/LeadComponentServices/index.js